/* This file is autogenerated, see readme.md for instructions */
import CopySvgIcon from '@bloomreach/banana-theme/icons/copy.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const CopyIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <CopySvgIcon />
    </Icon>
  );
});

CopyIcon.displayName = 'CopyIcon';

export default CopyIcon;
